export interface CarouselAppearanceSettings {
  carouselArrowBackgroundColor: string;
  carouselArrowColor: string;
  carouselArrowBackgroundColorOnHover: string;
  carouselArrowColorOnHover: string;
  carouselArrowSize: number;
  carouselPaginationColor: string;
}

export const carouselAppearanceDefaultSettings: CarouselAppearanceSettings = {
  carouselArrowBackgroundColor: 'rgba(17, 17, 17, 0.5)',
  carouselArrowColor: 'rgba(255, 255, 255, 1)',
  carouselArrowBackgroundColorOnHover: 'rgba(17, 17, 17, 1)',
  carouselArrowColorOnHover: 'rgba(255, 255, 255, 1)',
  carouselArrowSize: 32,
  carouselPaginationColor: 'rgba(17, 17, 17, 1)'
};

export const carouselAppearanceDefaultSettingsDark: CarouselAppearanceSettings =
  {
    carouselArrowBackgroundColor: 'rgba(255, 255, 255, 0.5)',
    carouselArrowColor: 'rgba(17, 17, 17, 1)',
    carouselArrowBackgroundColorOnHover: 'rgba(255, 255, 255, 1)',
    carouselArrowColorOnHover: 'rgba(17, 17, 17, 1)',
    carouselArrowSize: 32,
    carouselPaginationColor: 'rgba(255, 255, 255, 1)'
  };
